import { connect } from 'react-redux';

import { pathSelector } from '../selectors';
import Static from '../components/Static';

const mapStateToProps = (state) => {
  const { sellitemId, groupId, businessId } = pathSelector(state);

  return {
    sellitemId,
    groupId,
    businessId,
  };
};

export default connect(mapStateToProps)(Static);
